module.exports = __webpack_public_path__ + "static/media/avpro-logo-black.afd4863e.jpg";